import ModalPrompt from "@/app/components/ui/Modals/Prompt";
import { useModalActions } from "@/app/hooks/ui_hooks/useModalActions";
import { useModalState } from "@/app/hooks/ui_hooks/useModalState";
import { useState } from "react";

const DeleteTileModal = () => {
  const { setInvisible } = useModalActions("TILE_DELETE_MODAL");
  const { tileName, onConfirm } = useModalState("TILE_DELETE_MODAL") as {
    tileName?: string;
    onConfirm?: () => Promise<void> | void;
  };
  const [isDeleting, setIsDeleting] = useState(false);

  const handleConfirm = () => {
    setIsDeleting(true);
    Promise.resolve(onConfirm?.()).finally(() => {
      setIsDeleting(false);
      setInvisible();
    });
  };

  return (
    <ModalPrompt
      modalId="TILE_DELETE_MODAL"
      dialogClassName="sm:my-8 sm:w-full sm:max-w-md sm:p-6"
      isLoading={isDeleting}
      button={{
        primaryButtonText: "Yes, Delete",
        secondaryButtonText: "Cancel",
        primaryButtonClassname: "bg-red-600 hover:bg-red-500",
        primaryButtonDisabled: isDeleting,
        primaryCallback: handleConfirm,
        secondaryCallback: () => setInvisible(),
        shouldHideOnClick: false,
      }}
      title="Delete Tile"
      content={
        <p className="text-sm text-gray-600">
          Are you sure you want to delete <span className="font-semibold text-gray-900">{tileName || "this tile"}</span>?
          Please verify before proceeding.
        </p>
      }
    />
  );
};

export default DeleteTileModal;
